import React, { useState } from "react";
import "../assets/style.css";
import "tailwindcss/tailwind.css";
// import Footer from "./Footer";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faChevronLeft,
//   faChevronRight,
// } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

// Importing images
import paramoreBag from "../assets/images/APPAREL/paramore-bag.webp";
import fobMockup from "../assets/images/APPAREL/mockup.webp";
import puppiesMixer from "../assets/images/APPAREL/puppies.webp";
import lovinLifeFest from "../assets/images/APPAREL/lovin-life-fest.webp";
import lovinLifeCollage from "../assets/images/APPAREL/Lovin_Life_Photo_Collage2.webp";
import clevelandBaseball from "../assets/images/APPAREL/cleveland-baseball.webp";
import paramoreCleMockup from "../assets/images/APPAREL/paramore-cle-mockup.webp";
import homecomingFootball from "../assets/images/APPAREL/homecoming-football-stadium.webp";
import steelVengeance from "../assets/images/APPAREL/STEEVE.webp";
import kentStateBag from "../assets/images/APPAREL/0d98ae77-212b-42c0-9c00-17eb2dc24491_rw_1920.webp";
import akronBag from "../assets/images/APPAREL/3a1fbe17-b07b-4966-9ebc-a9d01fe4e5fb_rw_1920.webp";
import akronChineseNewYear from "../assets/images/APPAREL/uakronshirts.webp";
import paramoreDetroit from "../assets/images/APPAREL/paramore_detroit.webp";
import avocados from "../assets/images/APPAREL/avocados.webp";
import uaGreekLifeCollage from "../assets/images/APPAREL/UA Greek Life Collage Shirts 2023 VC-02.webp";
import runningOutOfTime from "../assets/images/APPAREL/running out of time-01.webp";
import cedarPointCollage from "../assets/images/APPAREL/cp poster 2 copy.webp";
import iowaFootballStadium from "../assets/images/APPAREL/iowa.webp";
import houseSticker from "../assets/images/APPAREL/house-sticker.webp";
import houseDrawing from "../assets/images/APPAREL/tote.webp";
import illustratedCollage from "../assets/images/APPAREL/e1869b4f-92c1-4e96-baa4-0ba88ad8fd78_rw_1920.webp";
import pikeHalloweenHouse from "../assets/images/APPAREL/pike-halloween.webp";
import pumpkinIllustration from "../assets/images/APPAREL/pumpkin-halloween.webp";
import gammaPhiWatercolor from "../assets/images/APPAREL/gamma phi watercolor copy.webp";
import indyBarCrawl from "../assets/images/APPAREL/indy bar crawl.webp";
import sigmaKappa from "../assets/images/APPAREL/sigma kappa.webp";
import blackParade from "../assets/images/BLACK PARADE/black parade tour 2025.webp";
import mcrYoung from "../assets/images/APPAREL/mcr when we were young.webp";
import whatsernameGreenDay from "../assets/images/APPAREL/whatsername.webp";
import panicYoung from "../assets/images/APPAREL/PANIC WWWY/panic when we were young.webp";
import ciaBuilding from "../assets/images/APPAREL/24-25_IA_Alumni spring appeal stickers_FINAL.webp";
import skBag from "../assets/images/APPAREL/bag.webp";
import alphaPhiHouse from "../assets/images/APPAREL/t shirt copy.webp";
import FullScreenImage from "./FullScreenImage";
import mcrDetroit2026 from "../assets/images/APPAREL/MCR Detroit 2026.webp";
import catGetWellCard from "../assets/images/APPAREL/Maria-cat-card.webp";
import mcrSonicTemple from "../assets/images/APPAREL/MCR Sonic Temple 2026.png";




// Main Illustrations component
const Illustrations = () => {
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  const images = [
    paramoreBag,
    fobMockup,
    puppiesMixer,
    lovinLifeFest,
    lovinLifeCollage,
    clevelandBaseball,
    paramoreCleMockup,
    homecomingFootball,
    steelVengeance,
    kentStateBag,
    akronBag,
    akronChineseNewYear,
    paramoreDetroit,
    avocados,
    uaGreekLifeCollage,
    runningOutOfTime,
    cedarPointCollage,
    iowaFootballStadium,
    houseSticker,
    houseDrawing,
    illustratedCollage,
    pikeHalloweenHouse,
    pumpkinIllustration,
    gammaPhiWatercolor,
    indyBarCrawl,
    sigmaKappa,
    mcrYoung,
    whatsernameGreenDay,
    blackParade,
    panicYoung,
    ciaBuilding,
    skBag,
    alphaPhiHouse,
    mcrDetroit2026,
    catGetWellCard,
    mcrSonicTemple,
  ];

  const handleImageClick = (src, index) => {
    setFullScreenImage(src);
    setCurrentIndex(index);
  };

  const handleCloseFullScreen = () => {
    setFullScreenImage(null);
    setCurrentIndex(null);
  };

  const handlePrevImage = () => {
    if (currentIndex > 0) {
      setFullScreenImage(images[currentIndex - 1]);
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNextImage = () => {
    if (currentIndex < images.length - 1) {
      setFullScreenImage(images[currentIndex + 1]);
      setCurrentIndex(currentIndex + 1);
    }

    
  };
  

  return (
    <>
      <div className="container mx-auto">
        <div className="p-5 sm:p-10">
          <h1
            className="text-center mb-8"
            style={{
              fontFamily: "Bebas Neue, sans-serif",
              color: "#6ac9cb",
              fontSize: "48px",
            }}
          >
            Illustrations
          </h1>
          <p className="text-left text-gray-600 mx-2 sm:mx-4 md:mx-8 lg:mx-0 xl:mx-32 2xl:mx-60 mb-6 leading-relaxed -mt-8">  
           These illustration pieces represent a range of designs and illustrations created
           using Adobe Illustrator, InDesign, Photoshop, and Fresco. Each illustration revolves around 
           understanding composition, where balance, hierarchy, and visual flow guide the viewer’s 
           eye. Typography was used to complement the imagery while reinforcing the message and tone 
           of each design. Creative illustration serves as the heart of these projects, 
           bringing concepts to life through color, form, and imaginative detail. 
           <br></br>
            <br></br>
            The work reflects a dedication to crafting visually engaging and meaningful designs that 
            communicate ideas clearly while demonstrating technical skill and artistic vision.
          
           
          </p>

          {/* Row 1: MCR, CIA, Panic */}
          <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-2 justify-items-center 
          items-start">
            {/* MCR Black Parade illustration */}
            <Link to="/MCRBlackParade">
              <div className="relative group">
                <img
                  src={blackParade}
                  className="w-full max-w-[68] md:max-w-[68] h-auto object-cover rounded cursor-pointer 
                  transition duration-300 hover:opacity-50 border-2 border-blue-400"
                  alt="Black Parade skeleton illustration"
                />
                <div className="absolute top-2 right-2 bg-white bg-opacity-0 group-hover:bg-opacity-90 
                transition duration-300 rounded-full w-10 h-10 flex items-center justify-center">
                  <span className="text-gray-800 text-2xl font-bold opacity-0 group-hover:opacity-100 
                  transition duration-300">
                    ↗
                  </span>
                </div>
              </div>
            </Link>

            {/* CIA Alumni building drawing */}
            <Link to="/CIABuildingSticker">
              <div className="relative group">
                <img
                  src={ciaBuilding}
                  className="w-full max-w-[68] md:max-w-[68] h-auto object-cover rounded 
                  cursor-pointer transition duration-300 hover:opacity-50 border-2 border-gray-200"

                  alt="CIA Alumni building drawing"
                />
                <div className="absolute top-2 right-2 bg-white bg-opacity-0 group-hover:bg-opacity-90 
                transition duration-300 rounded-full w-10 h-10 flex items-center justify-center">
                  <span className="text-gray-800 text-2xl font-bold opacity-0 group-hover:opacity-100 
                  transition duration-300">
                    ↗
                  </span>
                </div>
              </div>
            </Link>

            {/* Panic at the Disco When We Were Young 2025 */}
            <Link to="/PanicinVegas">
              <div className="relative group">
                <img
                  src={panicYoung}
                  className="w-full max-w-[68] md:max-w-[68] h-auto object-cover rounded 
                  cursor-pointer transition duration-300 hover:opacity-50 border-2 border-blue-400 
                  -mb-10 sm:mb-0"
                  alt="Panic! At the Disco When We Were Young Illustration"
                />
                <div className="absolute top-2 right-2 bg-white bg-opacity-0 group-hover:bg-opacity-90 
                transition duration-300 rounded-full w-10 h-10 flex items-center justify-center">
                  <span className="text-gray-800 text-2xl font-bold opacity-0 group-hover:opacity-100 
                  transition duration-300">
                    ↗
                  </span>
                </div>
              </div>
            </Link>
          </div>

          {/* Process Link */}
          {/* <p className="text-blue-500 underline cursor-pointer mt-4 text-center">
  <Link to="/ParamoreCollage">Check out my process!</Link>
</p> */}
        </div>

        {/* Row 2: Paramore, Sonic Temple 2026, Lovin Life */}
        <div
          className="
    grid
    grid-cols-1
    md:grid-cols-1
    lg:grid-cols-3
    gap-6
    justify-items-center
    items-start
    lg:-mt-12
  "
        >
          {/* Paramore bag collage */}
          <img
            src={paramoreBag}
            className="
  w-full
  max-w-[68]
  h-auto
  pr-5
  pl-5
  
  

  -mb-16              // Apply negative bottom margin on mobile
  sm:mb-0             // Reset bottom margin from small screens up
  
  sm:ml-4
  sm:pr-10
  sm:pl-10
  sm:mr-4
  sm:-mt-8
  sm:pt-0             // Remove top padding on small screens

  md:-mt-8
  md:mr-6
  md:ml-6
  md:pl-10
  md:pr-10

  lg:-mt-3
  lg:pr-0
  lg:pl-5
  lg:mr-0
  lg:ml-11

  xl:-mt-9
  xl:pt-5
  xl:mr-9

  xl:ml-20
  xl:pr-0

  2xl:-mt-10
  2xl:mr-0
  2xl:pr-0
  2xl:ml-11
  object-cover
  rounded
  mt-8

  cursor-pointer
  transition
  duration-300
  hover:opacity-50
  
  "
            onClick={() => handleImageClick(paramoreBag, images.indexOf(paramoreBag))}
            alt="paramore collage bag illustration"
          />

          {/* MCR Sonic Temple 2026 illustration */}
          <img
            src={mcrSonicTemple}
            className="

  w-full
  max-w-[68]
  h-auto
  p-5
  


  sm:ml-4
  sm:pr-10
  sm:pl-10
  sm:mr-4
  sm:-mt-6                // Small mobile margin-top
  sm:pt-2                 // Reduced padding-top on small mobile screens

  md:-mt-6
  md:pr-10
  md:pl-10

  lg:-mt-40
  lg:pt-3
  lg:pr-2
  lg:pl-2
  lg:mr-4

  xl:-mt-52
  xl:pt-4
  xl:mr-12
  xl:ml-12
  xl:pr-2

  2xl:-mt-64
  2xl:pt-5
  2xl:mr-8
  2xl:pr-2
  2xl:ml-8
  object-cover
  rounded
  mt-8
  cursor-pointer
  transition
  duration-300
  hover:opacity-50
"
            onClick={() => handleImageClick(mcrSonicTemple, images.indexOf(mcrSonicTemple))}
            alt="My Chemical Romance skeleton illustration for sonic temple 2026"
          />

          {/* Lovin Life Fest Illustrations 2024 */}
          <img
            src={lovinLifeFest}
            className="
    w-full 
    max-w-[68] 
    h-auto 


    -mt-16
    pt-8
    p-5
               // Default top margin on mobile
                // Default padding on mobile

    sm:p-0 
    sm:-mt-9 
    sm:mr-4 
    sm:ml-4 
    sm:pr-10
    sm:pl-10
  
    md:-mt-11 
    md:ml-8 
    md:mr-8 
    md:pt-2 
    md:pr-10 
    md:pl-10
  
    lg:mt-2 
    lg:mr-20 
    lg:pt-2 
    lg:ml-8
    lg:pr-4
    lg:pl-0
  
    xl:mt-1
    xl:ml-13 
    xl:mr-24 
    xl:pt-3 
    xl:pr-2
    xl:pl-2
  
    2xl:mt-4 
    2xl:ml-20 
    2xl:mr-32 
    2xl:pt-0 
    2xl:pr-4
    2xl:pl-0
  
  
    object-cover 
    rounded 
    mt-8 
    cursor-pointer 
    transition 
    duration-300 
    hover:opacity-50
  "
  onClick={() =>
    handleImageClick(lovinLifeFest, images.indexOf(lovinLifeFest))}
            alt="Loving Life music fest collage"
          />
        </div>

        {/* Row 3: MCR Detroit, When We Were Young, Halloween puppies */}
        <div
          className="grid
    grid-cols-1
    md:grid-cols-1
    lg:grid-cols-3 gap-2 justify-items-center items-start"
        >
          {/* MCR Detroit 2026 */}
          <img
            src={mcrDetroit2026}
            className="
            mx-auto
            h-auto
            max-w-full
          
            -mt-7           // Default top margin on mobile
            p-5
          
            sm:-mt-3
            sm:pr-10
            sm:pl-10
            s
          
            md:-mt-2
            md:p-4
            md:pr-16
            md:ml-6
          
            lg:-mt-36
            lg:pt-4
            lg:ml-6
            lg:pr-3 
            
          
            xl:-mt-44
          
            xl:ml-6
            xl:pr-3
          
            2xl:-mt-56
            2xl:pt-7
            2xl:ml-6
            2xl:
          
            object-cover
            rounded
            cursor-pointer
            transition duration-300 hover:opacity-50
          "
          onClick={() => handleImageClick(mcrDetroit2026, images.indexOf(mcrDetroit2026))}

            alt="My Chemical Romance Detroit 2026 skeleton illustration"
          />

          {/* MCR When We Were Young 2024 illustration */}
          <img
            src={mcrYoung}
            className="

  w-78
  h-auto
  object-cover
  rounded
  cursor-pointer
  
  -mt-9              // Adjust the margin-top for mobile only
   
  p-5
  
  sm:-mt-10        // Smaller negative margin on sm+
  sm:pr-10
  sm:pl-10
  
  md:mt-[-3em]
  md:pt-8
  md:p-10

  
  lg:-mt-40
  lg:pt-4
  lg:pr-3
  lg:pl-3
  
  xl:-mt-52
  xl:pt-7
  xl:pr-3
  xl:pl-3
  
  2xl:-mt-60
  2xl:pt-5
  2xl:pr-3
  2xl:pl-3
  
  transition duration-300 hover:opacity-50
"
onClick={() => handleImageClick(mcrYoung, images.indexOf(mcrYoung))}
            alt="My Chemical Romance when we were young 2023 skeleton moon illustration"
          />

          {/* Pumpkin Puppy illustration */}
          <img
            src={puppiesMixer}
            className="
  mx-auto
  mb-8
  -mt-9
  max-w-full
  h-auto
  object-cover
  rounded
 
  p-5
  cursor-pointer

  sm:-mt-10

  sm:pr-10
  sm:pl-10

  md:mt-[-4rem]
  md:px-10
  md:py-6

  lg:-mt-4
  lg:pl-0
  lg:pr-7
  lg:-ml-3

  xl:-mt-4
  xl:pr-7
  xl:pl-0
  xl:-ml-3

  2xl:-mt-4
  2xl:pr-5
  2xl:pl-2
  2xl:-ml-5
"
onClick={() => handleImageClick(puppiesMixer, images.indexOf(puppiesMixer))}
            alt="Pumpkin Puppy mixer illustration"
          />
        </div>

          {/* Row 4: Green Day, Lovin Life, Cat Card */}
          <div
          className="grid
    grid-cols-1
    md:grid-cols-1
    lg:grid-cols-3 gap-2 justify-items-center items-start"
        >
          {/* Green Day */}
          <img
            src={whatsernameGreenDay}
            className="
            mx-auto
            h-auto
            max-w-full
          
            -mt-16           // Default top margin on mobile
            pt-6
            p-5

          
            sm:-mt-20
            sm:pt-9

            sm:pr-10
            sm:pl-10
            
          
            md:-mt-16
            md:p-4
            md:pr-16
            md:ml-6
          
            lg:-mt-28
            lg:pt-3
            lg:ml-6
            lg:pr-3 
            
          
            xl:-mt-32
            xl:pt-5
          
            xl:ml-6
            xl:pr-3
          
            2xl:-mt-36
            2xl:pt-6
            2xl:ml-6
           
          
            object-cover
            rounded
            cursor-pointer
            transition duration-300 hover:opacity-50
          "
          onClick={() => handleImageClick(whatsernameGreenDay, images.indexOf(whatsernameGreenDay))}

            alt="Green Day Whatsername Pittsburgh Skeleton Illustration"
          />

          {/* Lovin Life illustration */}
          <img
            src={lovinLifeCollage}
            className="

  w-78
  h-auto
  object-cover
  rounded
  cursor-pointer
  
  -mt-8              // Adjust the margin-top for mobile only
  pt-5         // Default for mobile
  p-5
  
  sm:-mt-10        // Smaller negative margin on sm+
  sm:pr-10
  sm:pl-10
  
  md:mt-[-3em]
  md:pt-8
  md:p-10

  
  lg:-mt-32
  lg:pt-4
  lg:pr-3
  lg:pl-3
  
  xl:-mt-40
  xl:pt-9
  xl:pr-3
  xl:pl-3
  
  2xl:-mt-36
  2xl:pt-2
  2xl:pr-3
  2xl:pl-3
  
  transition duration-300 hover:opacity-50
"
onClick={() => handleImageClick(lovinLifeCollage, images.indexOf(lovinLifeCollage))}
            alt="Lovin life collage fest illustration"
          />

          {/* Cat get well illustration */}
          <img
            src={catGetWellCard}
            className="
  mx-auto
  mb-8
  -mt-9
  max-w-full
  h-auto
  object-cover
  rounded
 
  p-5
  cursor-pointer

  sm:-mt-10
  sm:pr-10
  sm:pl-10

  md:mt-[-4rem]
  md:px-10
  md:py-6

  lg:-mt-20
  lg:pt-8
  lg:pl-0
  lg:pr-7
  lg:-ml-3

  xl:-mt-20
  xl:pt-8
  xl:pr-7
  xl:pl-0
  xl:-ml-3

  2xl:-mt-20
  2xl:pt-8

  2xl:pr-5
  2xl:pl-2
  2xl:-ml-5
"
onClick={() => handleImageClick(catGetWellCard, images.indexOf(catGetWellCard))}
            alt="Cat get well card illustration"
          />
        </div>

        {/* Row 4: Cedar Point, Paramore Running out of Time, UAkron design */}
        <div
          className="grid
    grid-cols-1
    md:grid-cols-1
    lg:grid-cols-3 gap-2 justify-items-center items-start"
        >
          {/* Cedar Point Photo collage */}
          <img
            src={cedarPointCollage}
            className="
            w-68
            mx-auto
            -mt-16              // Default margin-top for mobile
            pt-6
            p-5
           
            sm:-mt-20           // Smaller negative margin for sm screens
            sm:pt-9
            sm:pr-10
            sm:pl-10

            md:-mt-20            // Smaller negative margin for md screens
            md:pt-8
            md:w-[1000px]
            md:pl-10
        
            md:pr-10

            lg:-mt-9            // Smaller negative margin for lg screens
            lg:pt-0
            lg:pl-7
            lg:pr-0
            lg:ml-3
            


            xl:-mt-12            // Larger negative margin for xl screens
            xl:pt-3
            xl:pr-1
            xl:pl-6
            xl:ml-4

            2xl:-mt-12         // Adjusted negative margin for 2xl screens
         
            2xl:pr-0
            2xl:pl-7
            2xl:ml-3

           
            h-auto
            object-cover
            rounded
     
            cursor-pointer
            transition duration-300 hover:opacity-50
          "
          onClick={() => handleImageClick(cedarPointCollage, images.indexOf(cedarPointCollage))}
            alt="Cedar Point roller coaster collage"
          />
          {/* Paramore Running out of Time concept art illustration */}
          <img
            src={runningOutOfTime}
            className="
  w-70
  h-auto
  object-cover
  -mt-8       /* Default for small mobile */
  pt-5
  p-5
  rounded

  cursor-pointer
  transition
  duration-300
  hover:opacity-50

  sm:-mt-10
  sm:px-8
  sm:mr-4

  md:-mt-12
  md:pt-7
  md:px-8
  md:mr-4

  lg:-mt-12
  lg:pt-4
  lg:pr-3
  lg:pl-3
  lg:ml-4

  xl:-mt-16
  xl:pt-8
  xl:pr-3
  xl:pl-3
  xl:ml-4

  2xl:-mt-20
  2xl:pt-12

  2xl:pr-3
  2xl:pl-4
  2xl:ml-2
"
onClick={() => handleImageClick(runningOutOfTime, images.indexOf(runningOutOfTime))}

            alt="Paramore Running out of Time concept art illustration"
          />

          {/* UAkron collage illustration */}
          <img
            src={uaGreekLifeCollage}
            className="
  mx-auto
  h-auto
  max-w-full
  object-cover
  rounded
  cursor-pointer
  transition
  duration-300
  hover:opacity-50

  -mt-8           /* Default for smallest screens */
  pt-5
  p-5


  sm:-mt-10
  sm:px-7
  sm:mr-4
  sm:pr-10

  md:-mt-10
  md:px-8
  md:ml-0
  md:mr-4

  lg:mt-[-14rem]
  lg:pt-8
  lg:pr-4
  lg:pl-3
  lg:ml-0
  lg:mr-12

  xl:-mt-60
  xl:pt-0
  xl:pr-4
  xl:pl-3
  xl:ml-0
  xl:mr-12

  2xl:-mt-72     /* cleaner way to express -mt-20 */
  2xl:pt-0
  2xl:pl-0
  2xl:pr-7
  2xl:ml-0
  2xl:mr-6
  2xl:w-[1500px]
  
"
onClick={() => handleImageClick(uaGreekLifeCollage, images.indexOf(uaGreekLifeCollage))}

            alt="University of Akron collage illustration"
          />
        </div>

        {/* Row 5: Fall Out Boy, Paramore Detroit, Homecoming football stadium */}
        <div
          className="grid
    grid-cols-1
    md:grid-cols-1
    lg:grid-cols-3 gap-2 justify-items-center items-start"
        >
          {/*Fall Out Boy */}
          <img
            src={fobMockup}
            className="
            mx-auto 
            max-w-full 
            h-auto 
            object-cover 
            rounded 
         
            cursor-pointer
          
            -mt-6          /* Default for mobile */
            p-5
          
            sm:-mt-8
            sm:px-7
            sm:mr-4
            sm:pr-10
          
            md:mt-[-2rem]
            md:pr-10
          
            lg:mt-[-4rem]
            lg:pt-3
            lg:pr-4
            lg:pl-3
            lg:ml-14
            lg:mr-0
          
            xl:mt-[-5rem]
            xl:pt-4
            xl:pr-4
            xl:pl-3
            xl:ml-13
            
          
            2xl:-mt-20
            2xl:pt-4
            2xl:pl-0 
            2xl:pr-7 
            2xl:ml-20 
            2xl:w-[1500px]
          "
          onClick={() => handleImageClick(fobMockup, images.indexOf(fobMockup))}

            alt="Fall Out Boy concept art"
          />
          {/* Paramore Detroit Tour 2023 Photo illustration */}
          <img
            src={paramoreDetroit}
            className="
  w-70 
  h-auto 
  object-cover 
  -mt-8
  pt-5 
  p-5
 
  rounded 

  cursor-pointer

  sm:-mt-10
  sm:px-7
  sm:mr-6

  md:-mt-10
  md:px-8
  md:mr-4

  lg:mt-[-3rem]
  lg:pt-9 
  lg:pr-3
  lg:pl-3
  lg:ml-4

  xl:mt-[-3rem] 
  xl:pr-3
  xl:pl-3
  xl:ml-4

  2xl:mt-[-2rem]
  2xl:pt-5 
  2xl:pl-0 
  2xl:pr-7 
  2xl:ml-10 
  2xl:w-[1500px]
"
onClick={() => handleImageClick(paramoreDetroit, images.indexOf(paramoreDetroit))}

            alt="Paramore Detroit Tour 2023 illustration"
          />

          {/* Homecoming football stadium illustration */}
          <img
            src={homecomingFootball}
            className="
            mx-auto
            h-auto
            max-w-full
            object-cover
            rounded
            cursor-pointer
            transition
            duration-300
            hover:opacity-50
          
            -mt-8            /* Default for smallest screens */
            p-5
            pt-5
          
          
            sm:-mt-10
            sm:px-7
            sm:mr-4
            sm:pr-10
          
            md:-mt-10
            md:px-8
            md:ml-0
            md:mr-4
          
            lg:mt-[-18rem]
            lg:pt-3
            lg:pr-4
            lg:pl-3
            lg:ml-0
            lg:mr-12
          
            xl:mt-[-22rem]
            xl:pt-0
            xl:pr-4
            xl:pl-3
            xl:ml-0
            xl:mr-12
          
            2xl:mt-[-27rem]     /* cleaner way to express -mt-20 */
            2xl:pt-4
            2xl:pl-0
            2xl:pr-7
            2xl:ml-0
            2xl:mr-6
            2xl:w-[1500px]
            
          "
          onClick={() => handleImageClick(homecomingFootball, images.indexOf(homecomingFootball))}

            alt="Homecoming football stadium illustration"
          />
        </div>

        {/* Row 6: Paramore Cleveland, Iowa Football, Steel Vengeance */}
        <div
          className="grid
    grid-cols-1
    md:grid-cols-1
    lg:grid-cols-3 gap-2 justify-items-center items-start"
        >
          {/*Paramore Cleveland Mockup  */}
          <img
            src={paramoreCleMockup}
            className="   mx-auto 
            max-w-full 
            h-auto 
            object-cover 
            rounded 
         
            cursor-pointer
          
            -mt-6          /* Default for mobile */
            p-5
          
            sm:-mt-8
            sm:px-7
            sm:mr-4
            sm:pr-10
          
            md:mt-[-2rem]
            md:pr-10
          
            lg:mt-[-13rem]
            lg:pt-4
            lg:pr-4
            lg:pl-3
            lg:ml-14
            lg:mr-0
          
            xl:mt-[-16rem]
            xl:pt-3
            xl:pr-4
            xl:pl-3
            xl:ml-13
            
          
            2xl:mt-[-18rem]
             2xl:pt-3
            2xl:pl-0 
            2xl:pr-7 
            2xl:ml-20 
            2xl:w-[1500px]
         "
         onClick={() => handleImageClick(paramoreCleMockup, images.indexOf(paramoreCleMockup))}

            alt="Paramore Cleveland Tour 2023 Design"
          />
          {/* Iowa Football stadium illustration */}
          <img
            src={iowaFootballStadium}
            className=" w-70 
    h-auto 
    object-cover 
    -mt-6
    pt-3 
    p-5
   
    rounded 
  
    cursor-pointer
  
    sm:-mt-8 
    sm:px-7

    sm:pr-10
    sm:pl-7
  
    md:mt-[-2rem] 
    md:px-8
    md:mr-4
  
    lg:mt-[-2rem]
    lg:pt-5 
    lg:pr-3
    lg:pl-3
    lg:ml-4
  
    xl:mt-[-2rem] 
    xl:pr-3
    xl:pl-3
    xl:ml-4
  
    2xl:mt-[-1rem]
    2xl:pt-1 
    2xl:pl-0 
    2xl:pr-7 
    2xl:ml-10 
    2xl:w-[1500px]"
    onClick={() => handleImageClick(iowaFootballStadium, images.indexOf(iowaFootballStadium))}

            alt="Iowa Football stadium illustration"
          />

          {/* Steel Vengeance illustration */}
          <img
            src={steelVengeance}
            className="   mx-auto
            h-auto
            max-w-full
            object-cover
            rounded
            cursor-pointer
            transition
            duration-300
            hover:opacity-50
          
            -mt-8            /* Default for smallest screens */
            p-5
            pt-5
          
          
            sm:-mt-10
            sm:px-7
            sm:mr-4
            sm:pr-10
          
            md:-mt-10
            md:px-8
            md:ml-0
            md:mr-4
          
            lg:mt-[-22rem]
            lg:pt-3
            lg:pr-4
            lg:pl-3
            lg:ml-0
            lg:mr-12
          
            xl:mt-[-28rem]
            xl:pt-4
            xl:pr-4
            xl:pl-3
            xl:ml-0
            xl:mr-12
          
            2xl:mt-[-34rem]     /* cleaner way to express -mt-20 */
            2xl:pt-10
            2xl:pl-0
            2xl:pr-7
            2xl:ml-0
            2xl:mr-6
            2xl:w-[1500px]"
            onClick={() => handleImageClick(steelVengeance, images.indexOf(steelVengeance))}

            alt="Steel Vengeance illustration"
          />
        </div>

        {/* Row 7: PIKE Halloween House, KSU Bag Collage, avocados */}
        <div
          className="grid
    grid-cols-1
    md:grid-cols-1
    lg:grid-cols-3 gap-2 justify-items-center items-start"
        >
          {/* PIKE Halloween House */}
          <img
            src={pikeHalloweenHouse}
            className=" mx-auto 
            max-w-full 
            h-auto 
            object-cover 
            rounded 
         
            cursor-pointer
          
            -mt-6          /* Default for mobile */
            p-5
          
            sm:-mt-8
            sm:px-7
            sm:mr-4
            sm:pr-10
          
            md:mt-[-2rem]
            md:pr-10
          
            lg:mt-[-9rem]
            lg:pt-3
            lg:pr-4
            lg:pl-3
            lg:ml-14
            lg:mr-0
          
            xl:mt-[-11rem]
            xl:pt-3
            xl:pr-4
            xl:pl-3
            xl:ml-13
            
          
            2xl:mt-[-11rem]
             2xl:pt-0
            2xl:pl-0 
            2xl:pr-7 
            2xl:ml-20 
            2xl:w-[1500px]"
            onClick={() => handleImageClick(pikeHalloweenHouse, images.indexOf(pikeHalloweenHouse))}

            alt="Pi Kappa Alpha Halloween house illustration"
          />
          {/* KSU bag collage illustration */}
          <img
            src={kentStateBag}
            className="  mx-auto
    h-auto
    max-w-full
    object-cover
    rounded
    cursor-pointer
    transition
    duration-300
    hover:opacity-50
  
    -mt-8            /* Default for smallest screens */
    p-5
   
  
  
    sm:-mt-10
    sm:px-7
    sm:mr-4
    sm:pr-10
  
    md:-mt-10
    md:px-8
    md:ml-0
    md:mr-4
  
    lg:mt-[-1rem]
    lg:pt-1
    lg:pr-3
    lg:pl-3
    lg:ml-0
    lg:mr-0
  
    xl:mt-[-2rem]
    xl:pt-5
    xl:pr-3
    xl:pl-3
    xl:ml-0
    xl:mr-0
  
    2xl:mt-[-2rem]     /* cleaner way to express -mt-20 */
    2xl:pt-5
    2xl:pl-0
    2xl:pr-7
    2xl:ml-6
    2xl:mr-0
    2xl:w-[1500px]"
    onClick={() => handleImageClick(kentStateBag, images.indexOf(kentStateBag))}

            alt="Kent State tote bag collage illustration"
          />

          {/* Avocados illustration */}
          <img
            src={avocados}
            className="  mx-auto
            h-auto
            max-w-full
            object-cover
            rounded
            cursor-pointer
            transition
            duration-300
            hover:opacity-50
          
            -mt-8           /* Default for smallest screens */
            p-5
        
          
          
            sm:-mt-10
            sm:px-7
            sm:mr-4
            sm:pr-10
          
             
            md:-mt-10
            md:px-8
            md:ml-0
            md:mr-4
          
            lg:mt-[-23rem]
            lg:pt-2
            lg:pr-4
            lg:pl-3
            lg:ml-0
            lg:mr-12
          
            xl:mt-[-29rem]
            xl:pt-1
            xl:pr-4
            xl:pl-3
            xl:ml-0
            xl:mr-12
          
            2xl:mt-[-36rem]     /* cleaner way to express -mt-20 */
            2xl:pt-11
            2xl:pl-0
            2xl:pr-7
            2xl:ml-0
            2xl:mr-6
            2xl:w-[1500px]"
            onClick={() => handleImageClick(avocados, images.indexOf(avocados))}

            alt="Avocado fruit illustration"
          />
        </div>

        {/* Row 8: CLE Baseball, Akron bag, Akron new year shirt */}
        <div
          className="grid
    grid-cols-1
    md:grid-cols-1
    lg:grid-cols-3 gap-2 justify-items-center items-start"
        >
          {/* CLE baseball */}
          <img
            src={clevelandBaseball}
            className="mx-auto 
                       max-w-full 
                       h-auto 
                       object-cover 
                       rounded 
                    
                       cursor-pointer
                     
                       -mt-6           /* Default for mobile */
                       p-5
                     
                       sm:-mt-8
                       sm:px-7
                       sm:mr-4
                       sm:pr-10
                     
                        
                       md:-mt-8
                       md:pr-10
                     
                       lg:mt-[-1rem]
                       lg:pt-1
                       lg:pr-4
                       lg:pl-3
                       lg:ml-14
                       lg:mr-0
                     
                       xl:mt-[-1rem]
                       xl:pt-1
                       xl:pr-4
                       xl:pl-3
                       xl:ml-13
                       
                     
                       2xl:mt-[-1rem]
                        2xl:pt-1
                       2xl:pl-0 
                       2xl:pr-7 
                       2xl:ml-20 
                       2xl:w-[1500px]"
                       onClick={() => handleImageClick(clevelandBaseball, images.indexOf(clevelandBaseball))}

            alt="Cleveland baseball stadium illustration"
          />

          {/* UA bag illustration */}
          <img
            src={akronBag}
            className=" mx-auto
    h-auto
    max-w-full
    object-cover
    rounded
    cursor-pointer
    transition
    duration-300
    hover:opacity-50
  
    -mt-8           /* Default for smallest screens */
    p-5

  
  
    sm:-mt-10
    sm:px-7
    sm:mr-4
    sm:pr-10
  
     
    md:-mt-10
    md:px-8
    md:ml-0
    md:mr-4
  
    lg:mt-[-4rem]
    lg:pt-6
    lg:pr-3
    lg:pl-3
    lg:ml-0
    lg:mr-0
  
    xl:mt-[-4rem]
    xl:pt-4
    xl:pr-3
    xl:pl-3
    xl:ml-0
    xl:mr-0
  
    2xl:mt-[-5rem]     /* cleaner way to express -mt-20 */
    2xl:pt-0
    2xl:pl-0
    2xl:pr-7
    2xl:ml-6
    2xl:mr-0
    2xl:w-[1500px]"
    onClick={() => handleImageClick(akronBag, images.indexOf(akronBag))}

            alt="University of Akron collage bag illustration"
          />

          {/* UA New Years shirt illustration */}
          <img
            src={akronChineseNewYear}
            className="  mx-auto
                       h-auto
                       max-w-full
                       object-cover
                       rounded
                       cursor-pointer
                       transition
                       duration-300
                       hover:opacity-50
                     
                       -mt-8            /* Default for smallest screens */
                       p-5
                     
                     
                     
                        
                       sm:-mt-10
                       sm:px-7
                       sm:mr-4
                       sm:pr-10
                     
                       md:-mt-10
                       md:px-8
                       md:ml-0
                       md:mr-4
                     
                       lg:mt-[-19rem]
                       lg:pt-2
                       lg:pr-4
                       lg:pl-3
                       lg:ml-0
                       lg:mr-12
                     
                       xl:mt-[-25rem]
                       xl:pt-4
                       xl:pr-4
                       xl:pl-3
                       xl:ml-0
                       xl:mr-12
                     
                       2xl:mt-[-29rem]     /* cleaner way to express -mt-20 */
                       2xl:pt-2
                       2xl:pl-0
                       2xl:pr-7
                       2xl:ml-0
                       2xl:mr-6
                       2xl:w-[1500px]"
                       onClick={() => handleImageClick(akronChineseNewYear, images.indexOf(akronChineseNewYear))}

            alt="University of Akron Chinese New Year shirt illustration"
          />
        </div>

        {/* Row 9: Graffiti, house, pumpkins */}
        <div
          className="grid
    grid-cols-1
    md:grid-cols-1
    lg:grid-cols-3 gap-2 justify-items-center items-start"
        >
          {/* SDT graffiti  */}
          <img
            src={skBag}
            className="mx-auto 
                       max-w-full 
                       h-auto 
                       object-cover 
                       rounded 
                    
                       cursor-pointer
                     
                       -mt-6           /* Default for mobile */
                       p-5
                     
                       sm:-mt-8
                       sm:px-7
                       sm:mr-4
                       sm:pr-10
                     
                        
                       md:mt-[-2rem]
                       md:pr-10
                     
                       lg:mt-[-7rem]
                       lg:pt-5
                       lg:pr-4
                       lg:pl-3
                       lg:ml-14
                       lg:mr-0
                     
                       xl:mt-[-7rem]
                       xl:pt-1
                       xl:pr-4
                       xl:pl-3
                       xl:ml-13
                       
                     
                       2xl:mt-[-6rem]
                        2xl:pt-0
                       2xl:pl-0 
                       2xl:pr-7 
                       2xl:ml-20 
                       2xl:w-[1500px]"
            onClick={() => handleImageClick(skBag, 0)}
            alt="Sigma Delta Tau graffiti style text illustration"
          />
          {/* house collage drawing illustration */}
          <img
            src={illustratedCollage}
            className=" mx-auto
               h-auto
               max-w-full
               object-cover
               rounded
               cursor-pointer
               transition
               duration-300
               hover:opacity-50
             
               -mt-8            /* Default for smallest screens */
               p-5
             
             
             
               sm:-mt-10
               sm:px-7
               sm:mr-4
               sm:pr-10
             
               
               md:-mt-10
               md:px-8
               md:ml-0
               md:mr-4
             
               lg:mt-[-2rem]
               lg:pt-5
               lg:pr-3
               lg:pl-3
               lg:ml-0
               lg:mr-0
             
               xl:mt-[-2rem]
               xl:pt-5
               xl:pr-3
               xl:pl-3
               xl:ml-0
               xl:mr-0
             
               2xl:mt-[-3rem]     /* cleaner way to express -mt-20 */
               2xl:pt-9
               2xl:pl-0
               2xl:pr-7
               2xl:ml-6
               2xl:mr-0
               2xl:w-[1500px]"
               onClick={() => handleImageClick(illustratedCollage, images.indexOf(illustratedCollage))}

            alt="house drawing campus collage illustration"
          />

          {/* Pumpkin illustration */}
          <img
            src={pumpkinIllustration}
            className="  mx-auto
                       h-auto
                       max-w-full
                       object-cover
                       rounded
                       cursor-pointer
                       transition
                       duration-300
                       hover:opacity-50
                     
                       -mt-8           /* Default for smallest screens */
                       p-5
                  
                     
                     
                       sm:-mt-10
                       sm:px-7
                       sm:mr-4
                       sm:pr-10
                     
                        
                       md:-mt-10
                       md:px-8
                       md:ml-0
                       md:mr-4
                     
                       lg:mt-[-21rem]
                       lg:pt-1
                       lg:pr-4
                       lg:pl-3
                       lg:ml-0
                       lg:mr-12
                     
                       xl:mt-[-27rem]
                       xl:pt-1
                       xl:pr-4
                       xl:pl-3
                       xl:ml-0
                       xl:mr-12
                     
                       2xl:mt-[-30rem]     /* cleaner way to express -mt-20 */
                       2xl:pt-1
                       2xl:pl-0
                       2xl:pr-7
                       2xl:ml-0
                       2xl:mr-6
                       2xl:w-[1500px]"
                       onClick={() => handleImageClick(pumpkinIllustration, images.indexOf(pumpkinIllustration))}

            alt="Pumpkin/fall illustration"
          />
        </div>

        {/* Row 10: Indy bar crawl, house, watercolor text */}
        <div
          className="grid
    grid-cols-1
    md:grid-cols-1
    lg:grid-cols-3 gap-2 justify-items-center items-start"
        >
          {/* Indy bar crawl collage */}
          <img
            src={indyBarCrawl}
            className="mx-auto 
                       max-w-full 
                       h-auto 
                       object-cover 
                       rounded 
                    
                       cursor-pointer
                     
                       -mt-6           /* Default for mobile */
                       p-5
                     
                       sm:-mt-8
                       sm:px-7
                       sm:mr-4
                       sm:pr-10
                     
                        
                       md:mt-[-2rem]
                       md:pr-10
                     
                       lg:mt-[-1rem]
                       lg:pt-1
                       lg:pr-4
                       lg:pl-3
                       lg:ml-14
                       lg:mr-0
                     
                       xl:mt-[-1rem]
                       xl:pt-1
                       xl:pr-4
                       xl:pl-3
                       xl:ml-13
                       
                     
                       2xl:mt-[-1rem]
                       2xl:pt-1
                       2xl:pl-0 
                       2xl:pr-7 
                       2xl:ml-20 
                       2xl:w-[1500px]"
                       onClick={() => handleImageClick(indyBarCrawl, images.indexOf(indyBarCrawl))}

            alt="Indiana bar crawl collage illustration"
          />
          {/* House illustration */}
          <img
            src={houseSticker}
            className="mx-auto
               h-auto
               max-w-full
               object-cover
               rounded
               cursor-pointer
               transition
               duration-300
               hover:opacity-50
             
               -mt-8           /* Default for smallest screens */
               p-5
           
             
             
               sm:-mt-10
               sm:px-7
               sm:mr-4
               sm:pr-10
             
                
               md:-mt-10
               md:px-8
               md:ml-0
               md:mr-4
             
               lg:mt-[-10rem]
               lg:pt-0
               lg:pr-3
               lg:pl-3
               lg:ml-0
               lg:mr-0
             
               xl:mt-[-13rem]
               xl:pt-0
               xl:pr-3
               xl:pl-3
               xl:ml-0
               xl:mr-0
             
               2xl:mt-[-18rem]     /* cleaner way to express -mt-20 */
               2xl:pt-0
               2xl:pl-0
               2xl:pr-7
               2xl:ml-6
               2xl:mr-0
               2xl:w-[1500px]"
               onClick={() => handleImageClick(houseSticker, images.indexOf(houseSticker))}

            alt="Cartoon style house illustration"
          />

          {/* Gamma Phi watercolor  */}
          <img
            src={gammaPhiWatercolor}
            className="  mx-auto
                       h-auto
                       max-w-full
                       object-cover
                       rounded
                       cursor-pointer
                       transition
                       duration-300
                       hover:opacity-50
                     
                       -mt-8           /* Default for smallest screens */
                       p-5
                       
                     
                     
                       sm:-mt-10
                       sm:px-7
                       sm:mr-4
                       sm:pr-10
                     
                        
                       md:-mt-10
                       md:px-8
                       md:ml-0
                       md:mr-4
                     
                       lg:mt-[-22rem]
                       lg:pt-2
                       lg:pr-4
                       lg:pl-3
                       lg:ml-0
                       lg:mr-12
                     
                       xl:mt-[-29rem]
                       xl:pt-3
                       xl:pr-4
                       xl:pl-3
                       xl:ml-0
                       xl:mr-12
                     
                       2xl:mt-[-34rem]     /* cleaner way to express -mt-20 */
                       2xl:pt-2
                       2xl:pl-0
                       2xl:pr-7
                       2xl:ml-0
                       2xl:mr-6
                       2xl:w-[1500px]"
                       onClick={() => handleImageClick(gammaPhiWatercolor, images.indexOf(gammaPhiWatercolor))}

            alt="Gamma Phi watercolor illustration"
          />
        </div>

       
        


      </div>

      {fullScreenImage && (
  <FullScreenImage
    src={fullScreenImage}
    onClose={handleCloseFullScreen}
    onPrev={handlePrevImage}
    onNext={handleNextImage}
  />
)}

    </>
  );
};

export default Illustrations;